import { z } from "zod";

export const presentOptionsChoiceOptionSchema = z.object({
	id: z
		.string()
		.min(1)
		.describe("Stable option id returned when the user selects"),
	label: z
		.string()
		.min(1)
		.describe("Short label shown on the selection button"),
	description: z
		.string()
		.optional()
		.describe("Optional longer description for the option"),
});

export const presentOptionsInputSchema = z.object({
	prompt: z
		.string()
		.min(1)
		.describe("Question or instruction shown above the option buttons"),
	options: z
		.array(presentOptionsChoiceOptionSchema)
		.min(2)
		.max(8)
		.describe("Selectable options; use 2-8 items"),
});

export const presentOptionsOutputSchema = z.object({
	choiceId: z.string().min(1),
	prompt: z.string().min(1),
	options: z.array(presentOptionsChoiceOptionSchema).min(2).max(8),
	awaitingSelection: z.literal(true),
});

export type PresentOptionsOutput = z.infer<typeof presentOptionsOutputSchema>;
